/**
 * Code calls
 */
export const getRolesByUserId = 'right/getRolesByUserId';
export const getRoles = 'right/getRoles';
export const getOwnRights = 'right/getOwnRights';
export const postRoleGroupUser = 'right/postRoleGroupUser';
export const deleteRoleGroupUser = 'right/deleteRoleGroupUser';
export const addUserRightsByEmail = 'right/addUserRightsByEmail';
